module.exports = __webpack_public_path__ + "img/icon-episode-folder.b0148723.svg";